<template>
  <div class="h-full">
    <section
      class="flex flex-col items-center justify-center px-4 text-center text-white cover"
    >
      <div class="flex flex-col items-center justify-start mx-auto -mt-16">
        <div class="mb-6 text-4xl">
          <h3 v-if="!isEmailVerify">Validate your email</h3>
          <div v-else>
            <h3>
              <span v-if="isNewUser">Register your account</span>
              <span v-else>Login to your account</span>
              <br />
              <span class="text-lg">
                Please, the complete the fields to continue
                <span v-if="isNewUser"> with your registration</span>
              </span>
            </h3>
          </div>
        </div>

        <form
          class="flex flex-col items-center w-full max-w-sm"
          @submit.prevent
        >
          <div class="flex flex-col w-full space-y-5">
            <base-input
              v-model="email"
              v-validate="'required|email'"
              name="email"
              :inputClass="`text-white rounded-md w-full bg-gray-500 ${
                isEmailVerify ? 'cursor-not-allowed' : ''
              }`"
              placeholder="Email"
              :disabled="isEmailVerify"
              :message="errors.first('email')"
            />
            <base-input
              v-if="isEmailVerify"
              ref="password"
              v-model="password"
              v-validate="{
                required: true,
                min: 8,
                verify_password: isNewUser,
              }"
              name="password"
              class="w-full mt-4"
              inputClass="bg-gray-500 text-white"
              placeholder="Password"
              type="password"
              :message="errors.first('password')"
            />
            <base-input
              v-if="isNewUser && isEmailVerify"
              v-model="password_confirmation"
              v-validate="'required|confirmed:password'"
              name="password_confirmation"
              data-vv-as="password confirmation"
              class="w-full mt-4"
              inputClass="bg-gray-500 text-white"
              placeholder="Confirm password"
              type="password"
              :message="errors.first('password_confirmation')"
            />
          </div>

          <button
            v-if="!isEmailVerify"
            class="mt-10 rounded-md btn"
            :disabled="isLoading"
            @click="verifyEmailHandler"
          >
            Continue
          </button>
          <button
            v-else
            class="mt-10 rounded-md btn"
            :disabled="isLoading"
            @click="confirmationHandler"
          >
            <span v-if="isNewUser">Register Account</span>
            <span v-else>Continue</span>
          </button>
        </form>
      </div>
    </section>

    <base-footer />
  </div>
</template>

<script>
import AuthService from "@/services/AuthService";
import { mapActions, mapState } from "vuex";

export default {
  data() {
    return {
      email: "",
      password: "",
      password_confirmation: "",
      isLoading: false,
      isEmailVerify: false,
      isNewUser: true,
      hasEmail: false,
      isValid: false,
    };
  },
  computed: {
    ...mapState("auth", ["tempSnapchatAccessToken"]),
  },
  methods: {
    ...mapActions("auth", ["loginWithSnapchat", "setTempSnapchatAccessToken"]),

    async verifyEmailHandler() {
      this.isEmailVerify = false;

      try {
        this.isValid = await this.$validator.validateAll();
        if (this.isLoading || !this.isValid) return;

        this.isLoading = true;

        // verify account exist in snapchat
        const { userExists } = await AuthService.verifyEmailWithSnapchat(
          this.email
        );

        // if user exists, set isNewUser to false and true if not
        this.isNewUser = !userExists;
        this.isEmailVerify = true;
      } catch (e) {
        this.$toasted.show(e.response.data.message, {
          type: "error",
          duration: 5000,
        });
      } finally {
        this.isLoading = false;
      }
    },

    async confirmationHandler() {
      try {
        this.isValid = await this.$validator.validateAll();

        if (this.isLoading || !this.isValid) return;
        this.isLoading = true;

        // confirm account in snapchat and get access token
        const { token } = await AuthService.confirmAccountWithSnapchat({
          email: this.email,
          password: this.password,
          accessToken: this.tempSnapchatAccessToken,
        });

        if (!token) {
          this.$toasted.show("Something went wrong, try again in a minute.", {
            type: "error",
            duration: 5000,
          });
          return this.$router.push("/login");
        }

        // login with snapchat
        await this.loginWithSnapchat(token);
        // If is authenticated, fetch user data
        if (this.isAuthenticated) {
          await this.fetch();
        }

        // clear form data
        this.$validator.pause();
        this.setTempSnapchatAccessToken(null);
        this.email = "";
        this.password = "";
        this.password_confirmation = "";

        // notify user that account was confirmed/registered
        this.$toasted.show(
          `Account ${this.isNewUser ? "registered" : "confirmed"} successfully`,
          {
            type: "success",
            duration: 5000,
          }
        );

        // redirect to stations view
        this.$router.push({ name: "stations" });
      } catch (err) {
        this.$toasted.show(err.response.data.message, {
          type: "error",
          duration: 5000,
        });
      } finally {
        this.isLoading = false;
        // redirect to stations view
        this.$router.push({ name: "stations" });
      }
    },
  },
};
</script>

<style scoped>
.cover {
  background-image: url("/images/background.jpg");
  height: calc(100% - 64px);
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
</style>
